/**
 * @description 季报高光时刻组件
 * @date 2025-01-24
 * @author lv.chen
 */
import React from 'react';
import classnames from 'classnames';
import Image from '@user-center/components/Image';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getGameEntityTypeClassName } from '../../../utils';

import ICON_PAGE from '../../assets/svgs/icon-page.svg';
import ICON_VISIT from '@user-center/assets/svgs/quarter-report/icon-visit.svg';

interface IHighlightMomentProps extends IBaseProps {
  quarterChars?: string;
  report?: IQuarterReportDetails | null;
}

/**
 * 季报高光时刻组件
 */
const HighlightMoment: React.FC<IHighlightMomentProps> = (props) => {
  const { style, className, quarterChars, report } = props;

  const { formatMessage } = useIntlExtend();

  // 获取最常访问游戏数据
  const topVisitedGame = report?.top_visit_game?.[0];
  // 获取最常访问次数数据
  const topVisitedTimes = report?.top_visit_times?.[0];

  return (
    <div style={style} className={classnames('hight-moment', className, { '--no-visit': !topVisitedGame })}>
      <div className="quarter-report-title">
        <span>{formatMessage({ id: 'dbu_quarter_report_highlight_moment' })}</span>
      </div>
      <div className="hight-moment-content">
        <div className="hight-moment-list">
          <div className="hight-moment-item">
            <div className="hight-moment-item-icon">
              <Image src={ICON_PAGE} />
            </div>
            <div className="hight-moment-item-title">
              <span>{formatMessage({ id: 'dbu_quarter_report_most_visited_page' }, { quarter: quarterChars })}</span>
            </div>
            <div className="hight-moment-item-desc">「{report?.top_visit_page}」</div>
          </div>
          {!!topVisitedGame && (
            <div className="hight-moment-item">
              <div
                className={classnames(
                  'hight-moment-item-image',
                  getGameEntityTypeClassName(topVisitedGame.entity_type),
                )}
              >
                <Image src={topVisitedGame.cover || ''} />
              </div>
              <div className="hight-moment-item-title">
                <span>{topVisitedGame.date}</span>
              </div>
              <div className="hight-moment-item-desc">
                {formatMessage(
                  { id: 'dbu_quarter_report_visited_game_on_date' },
                  { gameName: topVisitedGame.game_name },
                )}
              </div>
              <div className="hight-moment-item-nums">
                <span className="--num">{topVisitedGame.times}</span>
                {formatMessage({ id: 'dbu_quarter_report_times_unit' })}
              </div>
            </div>
          )}
          <div className="hight-moment-item">
            <div className="hight-moment-item-icon">
              <Image src={ICON_VISIT} />
            </div>
            <div className="hight-moment-item-title">
              <span>{topVisitedTimes?.date}</span>
            </div>
            <div className="hight-moment-item-desc">
              {formatMessage({ id: 'dbu_quarter_report_visited_databrain_on_date' })}
            </div>
            <div className="hight-moment-item-nums">
              <span className="--num">{topVisitedTimes?.times}</span>
              {formatMessage({ id: 'dbu_quarter_report_times_unit' })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HighlightMoment;
